module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "heading has-text-centered"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])]), _vm._t("default")], 2)]), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57815d2f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ModalContainer.vue
// module id = 423
// module chunks = 0